import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const localizer = momentLocalizer(moment);

const EventModal = ({ isOpen, onClose, isEditingEvent, profEvent, selectedEvent }) => {

  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem('token');

  const [startDateTime, setStartDateTime] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  const [endTime, setEndTime] = useState("");

  // ✅ Helper function to safely show values
  const safeValue = (val) => {
    if (val === null || val === undefined || val === "") {
      return "N/A";
    }
    return val;
  };

  useEffect(() => {
    if (profEvent && profEvent.data && profEvent.data.length > 0) {
      const event = profEvent.data[0];

      const combinedStart = `${event.actual_StartDate_Time || ""}`;
      const combinedStartTime = `${event.start_time || ""}`;
      const combinedEnd = `${event.actual_EndDate_Time || ""}`;
      const combinedEndTime = `${event.end_time || ""}`;

      if (combinedStart.trim()) {
        setStartDateTime(moment(combinedStart, "YYYY-MM-DD").format("DD-MM-YYYY"));
        setStartTime(moment(combinedStartTime, "HH:mm:ss").format("HH:mm"));
      } else {
        setStartDateTime("N/A");
        setStartTime("N/A");
      }

      if (combinedEnd.trim()) {
        setEndDateTime(moment(combinedEnd, "YYYY-MM-DD").format("DD-MM-YYYY"));
        setEndTime(moment(combinedEndTime, "HH:mm:ss").format("HH:mm"));
      } else {
        setEndDateTime("N/A");
        setEndTime("N/A");
      }
    }
  }, [profEvent]);

  const handleSave = () => {
    if (isEditingEvent) {
      onClose();
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 390,
          height: 500,
          overflowY: "auto",
          background: 'white',
          borderRadius: '10px',
          pt: 2,
          pb: 3,
          pl: 4,
          pr: 4
        }}
      >
        <AppBar
          position="static"
          style={{
            background: 'goldenrod',
            width: '23.8rem',
            height: '3rem',
          }}
        >
          <div style={{ display: "flex" }}>
            <Typography
              align="center"
              style={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#FFFFFF",
                marginTop: "10px",
                marginLeft: "10px"
              }}
            >
              PROFESSIONAL SCHEDULE
            </Typography>
            <Button onClick={onClose} sx={{ marginLeft: "6.5rem", color: "#FFFFFF", marginTop: "2px" }}>
              <CloseIcon />
            </Button>
          </div>
        </AppBar>

        <CardContent>
          <Grid container spacing={3} sx={{ marginTop: "1px", pl: 2, pr: 2 }}>

            <Grid item lg={12}>
              <TextField
                label="Professional Name"
                size="small"
                fullWidth
                value={safeValue(profEvent?.prof_name)}
                InputLabelProps={{ shrink: true }}
                sx={{ '& input': { fontSize: '14px' } }}
              />
            </Grid>

            <Grid item lg={12}>
              <TextField
                label="Patient Name"
                size="small"
                fullWidth
                value={safeValue(profEvent?.patient_name)}
                InputLabelProps={{ shrink: true }}
                sx={{ '& input': { fontSize: '14px' } }}
              />
            </Grid>

            <Grid item lg={12}>
              <TextField
                label="Service Name"
                size="small"
                fullWidth
                value={safeValue(profEvent?.srv_name)}
                InputLabelProps={{ shrink: true }}
                sx={{ '& input': { fontSize: '14px' } }}
              />
            </Grid>

            <Grid item lg={12}>
              <TextField
                label="Sub Service Name"
                size="small"
                fullWidth
                value={safeValue(profEvent?.sub_srv_id)}
                InputLabelProps={{ shrink: true }}
                sx={{ '& input': { fontSize: '14px' } }}
              />
            </Grid>

            <Grid item lg={12}>
              <TextField
                label="Service Amount"
                size="small"
                fullWidth
                value={safeValue(profEvent?.Service_final_amount)}
                InputLabelProps={{ shrink: true }}
                sx={{ '& input': { fontSize: '14px' } }}
              />
            </Grid>

            <Grid container spacing={2} sx={{ marginTop: "1px", ml: 1 }}>
              <Grid item lg={6}>
                <TextField
                  label="Start Date"
                  size="small"
                  fullWidth
                  value={safeValue(startDateTime)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& input': { fontSize: '14px' } }}
                />
              </Grid>
              <Grid item lg={6}>
                <TextField
                  label="Start Time"
                  size="small"
                  fullWidth
                  value={safeValue(startTime)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& input': { fontSize: '14px' } }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ marginTop: "1px", ml: 1 }}>
              <Grid item lg={6}>
                <TextField
                  label="End Date"
                  size="small"
                  fullWidth
                  value={safeValue(endDateTime)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& input': { fontSize: '14px' } }}
                />
              </Grid>
              <Grid item lg={6}>
                <TextField
                  label="End Time"
                  size="small"
                  fullWidth
                  value={safeValue(endTime)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ '& input': { fontSize: '14px' } }}
                />
              </Grid>
            </Grid>

            <Grid item lg={12}>
              <TextField
                label="Patient Location"
                size="small"
                fullWidth
                value={safeValue(profEvent?.patient_add)}
                InputLabelProps={{ shrink: true }}
                sx={{ '& input': { fontSize: '14px' } }}
              />
            </Grid>

            <Grid item lg={12} sx={{ marginLeft: "20px" }}>
              {isEditingEvent && (
                <Button variant="contained" onClick={handleSave}>Save</Button>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Box>
    </Modal>
  );
};

export default EventModal;
